import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
var children = /*#__PURE__*/new Map();
var sessionIdIndex = 0;
var registry = {
  bookId: function bookId() {
    return "x:" + sessionIdIndex++;
  },
  register: function register(id, actor) {
    children.set(id, actor);
    return id;
  },
  get: function get(id) {
    return children.get(id);
  },
  free: function free(id) {
    children.delete(id);
  }
};
export { registry };